/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_DrinksInputs */

const en_store_drinks = /** @type {(inputs: Store_DrinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drinks`)
};

const de_store_drinks = /** @type {(inputs: Store_DrinksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Getränke`)
};

/**
* | output |
* | --- |
* | "Drinks" |
*
* @param {Store_DrinksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const store_drinks = /** @type {((inputs?: Store_DrinksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_DrinksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_store_drinks(inputs)
	return en_store_drinks(inputs)
});